import React from "react";

// Reusable page-header hero for interior pages.
export default function PageHero({ eyebrow, title, subtitle, children }) {
  return (
    <section className="relative pt-40 sm:pt-44 pb-14 sm:pb-20 overflow-hidden">
      <div className="hero-glow" />
      <div className="absolute inset-0 grid-pattern opacity-30 dark:opacity-20" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {eyebrow && (
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary" data-testid="page-hero-eyebrow">
            {eyebrow}
          </p>
        )}
        <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 text-base sm:text-lg text-muted-foreground max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}
